import { render, staticRenderFns } from "./XgPlayer.vue?vue&type=template&id=ac539cda&scoped=true"
import script from "./XgPlayer.vue?vue&type=script&lang=js"
export * from "./XgPlayer.vue?vue&type=script&lang=js"
import style0 from "./XgPlayer.vue?vue&type=style&index=0&id=ac539cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac539cda",
  null
  
)

export default component.exports